'use client';

import Link from "next/link";
import React from "react";

const NotFoundPage = () => {
  return (
    <div className="min-h-screen px-2 flex flex-col justify-center items-center bg-gradient-to-br from-[#eaf3ff] via-[#dbeafe] to-[#b6d0f7]">
      <div className="flex flex-col md:flex-row items-center justify-center w-full max-w-4xl px-6 py-12 rounded-xl shadow-lg bg-white/80">
        <div className="flex-1 flex flex-col justify-center items-center md:items-center text-center md:text-left">
          <div className="text-7xl font-SegoeUI font-extrabold text-[#016767] mb-2 flex items-center justify-center">
            4
            <span 
                className="animate-spin-slow px-4 hover:animate-spin-fast"
            > 0
            
            </span>
            4
          </div>
          <h1 className="text-3xl md:text-4xl font-bold font-SegoeUI text-[#016767] mb-4">Page Not Found</h1>
          <p className="text-lg text-[#505B6A] mb-4">
            Oops! The page you’re looking for doesn’t exist or has been moved.
          </p>
          <Link
            href="/"
            className="inline-block font-SegoeUI px-6 py-3 bg-[#016767] text-white font-semibold rounded-lg shadow hover:bg-[#1e3a8a] transition"
          >
            Back to Home
          </Link>
        </div>
      </div>
      <style jsx>{`
        .animate-spin-slow {
          animation: spin 3s linear infinite;
        }
        .animate-spin-fast {
          animation: spin 1s linear infinite;
        }
        @keyframes spin {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </div>
  );
};

export default NotFoundPage;